namespace ui
{
	export namespace tab
	{
		export type NavBarStylesAlign = "tabs"|"pills"|"left"|"right";

		export class TabControl
		{
			private m_ID: string;
			private m_Bar: Bar;
			private m_Root: JQuery<HTMLElement>;
			private	m_Style: NavBarStylesAlign;
			private	m_NavSize: number;
			private m_ContentPane: JQuery<HTMLElement>;

			constructor( style: NavBarStylesAlign, nav_size: number = 2, keepLast: boolean = false )
			{
				this.m_ID						= Math.ceil( Math.random() * 1000 + new Date().getTime() ).toString().replace( '.', '_' );

				this.m_Root					= ui.$$.div();
				this.m_ContentPane	= ui.$$.div();

				this.m_ContentPane.addClass( 'tab-content' );
				this.m_NavSize			= clamp( nav_size, 1, 11 );

				this.m_Bar	= new Bar( this, 'tabs', this.m_ID, keepLast );

				this.m_Style = style;
				this.Style( style );
			}

			public BarInABox( yes: boolean ): void
			{
				if ( yes )
				{
					this.m_Bar.Root().addClass( 'box sticky-box' );
				}
			}

			public addTab(
				title: string,
				presenter: TabHTMLPresentation,
				show: boolean = true,
				close: boolean = true,
				reload: boolean = false
			): void
			{
				// Logic moved from TabBar
				const foundTab = this.getTab(title);
				if (foundTab) {
					this.m_Bar.notify({type: 'show', entry: foundTab});
					return;
				}

				// Redraw tabs once for now!
				const entry = this.m_Bar.addTab( title, presenter, close, reload );

				entry.Pane().appendTo( this.m_ContentPane );

				presenter.rebuild( entry.Pane() );

				if ( show )
				{
					this.m_Bar.notify( { type: 'show', entry } );
				}
			}

			public updateTab(title: string): void
			{
				const foundTab = this.m_Bar.getTab(title);

				if (foundTab)
				{
					foundTab.update({type: 'reload', entry: foundTab});
				}
			}

			public getTab(title: string): Entry | false
			{
				const foundTab = this.m_Bar.getTab(title);

				return foundTab;
			}

			public  removeAllTabs(): void
			{
				for (const entry of this.m_Bar.getAllTabs())
				{
					this.removeTab(entry);
				}
			}

			public removeTab( entry?: Entry ): void
			{
				if ( !entry ) { return; }

				this.m_Bar.notify( { entry, type: 'remove' } );
			}

			public Style( style?: NavBarStylesAlign ): string|void
			{
				if ( style )
				{

					if ( style === this.m_Style )
					{
						return;
					}

					this.m_Style	= style;

					if ( this.m_Style === "left" || this.m_Style === "right" )
					{
						this.m_Bar.Style( 'stacked' );

						if ( this.m_Style === 'right' )
						{
							this.m_Bar.Root().addClass( 'right' );
						}
						else
						{
							this.m_Bar.Root().addClass( 'left' );
						}
					}
					else
					{
						this.m_Bar.Style( this.m_Style );
					}

					return;
				}

				return this.m_Style;
			}

			public Build(): void
			{
				this.m_Root.empty();
				this.m_Root.removeClass();

				this.m_Root.append( this.m_Bar.Root() );

				if ( this.m_Style === "left" || this.m_Style === "right" )
				{
					this.m_Root.addClass( 'container-fluid' );

					const row = ui.$$.div();
					const left = ui.$$.div();
					const right = ui.$$.div();

					this.m_Root.append( row );

					row.addClass( 'row' );
					row.append( left );
					row.append( right );

					if ( this.m_Style === 'right' )
					{
						right.addClass( 'col-xs-12' );
						right.addClass( 'col-sm-' + this.m_NavSize );

						right.append( this.m_Bar.Root() );

						// right.css( 'max-height', this.calculateHeight() + 'px' );
						right.css( 'overflow-y', 'auto' );

						left.addClass( 'col-xs-12' );
						left.addClass( 'col-sm-' + ( 12 - this.m_NavSize ) );

						left.append( this.m_ContentPane );
					}
					else
					{
						left.addClass( 'col-xs-12' );
						left.addClass( 'col-sm-' + this.m_NavSize );

						left.append( this.m_Bar.Root() );

						// left.css( 'max-height', this.calculateHeight() + 'px' );
						left.css( 'direction', 'rtl' );
						left.css( 'overflow-y', 'auto' );

						right.addClass( 'col-xs-12' );
						right.addClass( 'col-sm-' + ( 12 - this.m_NavSize ) );

						right.append( this.m_ContentPane );
					}
				}
				else
				{
					this.m_Root.append( this.m_ContentPane );
				}

				this.m_Bar.Build();
			}

			public Root(): JQuery<HTMLElement>
			{
				return this.m_Root;
			}
		}
	}
}
